export default "__VITE_ASSET__kzE6Yk0n__"